import { createFileRoute, redirect } from '@tanstack/react-router';

// Document viewer
function HomeComponent() {
  return <></>;
}

// We move under the {auth} wrapper for simplicity
export const Route = createFileRoute('/')({
  component: HomeComponent,
  beforeLoad: () => {
    throw redirect({ to: '/documents' });
  },
});
